// module
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SlickCarousel from 'react-slick';
import 'slick-carousel/slick/slick.css';

// local
import styles from './Carousel.pcss';
import Arrow from './Arrow';

const Null = () => null;

export default class Carousel extends PureComponent {
  
  static propTypes = {
    // each child becomes a slide
    children: PropTypes.node,
    className: PropTypes.string,
  }
  static defaultProps = {
  }
  
  get sliderOpts() {
    const { children } = this.props;
    const multi = (children.length > 1);
    
    return {
      autoplay: false,
      dots: multi,
      dotsClass: styles.dots,
      draggable: false,
      infinite: true,
      nextArrow: (<Null />),
      prevArrow: (<Null />),
      swipe: multi,
    };
  }
  
  saveRef = (ref) => (this.slider = ref)
  prev = () => {
    const { children } = this.props;
    if (children.length < 2) return;
    this.slider.slickPrev();
  }
  next = () => {
    const { children } = this.props;
    if (children.length < 2) return;
    this.slider.slickNext();
  }
  
  render() {
    const { className, children, ...restProps } = this.props;
    
    const multi = (children.length > 1);
    
    if (!children || !children.length) return null;
    
    const classes = classnames(className, styles.carousel, {
      // todo: handle single / multi in a nicer way
      [styles.single]: (children.length === 1),
    });
    
    return (
      <div className={ classes }>
        <SlickCarousel
          ref={ this.saveRef }
          children={ children }
          { ...restProps }
          { ...this.sliderOpts } />
        <Arrow
          className={ styles.prev }
          dir={ 'left' }
          hidden={ !multi }
          // eslint-disable-next-line react/jsx-handler-names
          onClick={ this.prev } />
        <Arrow
          className={ styles.next }
          dir={ 'right' }
          hidden={ !multi }
          // eslint-disable-next-line react/jsx-handler-names
          onClick={ this.next } />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Carousel/index.jsx